import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["toggle"];
  static values = { limit: Number };

  connect() {
    const rows = this.element.querySelectorAll("tbody tr");
    rows.forEach((row, i) => {
      if (i >= this.limitValue) row.classList.add("d-none");
    });
  }

  expand() {
    this.element.querySelectorAll("tbody tr.d-none").forEach((row) => {
      row.classList.remove("d-none");
    });
    this.toggleTarget.remove();
  }
}
